import jiffy from "../assets/img/jiffy.png";
import jiffy2 from "../assets/img/jiffy2.png";
import jiffy3 from "../assets/img/jiffy3.png";
//
export interface LinkModel {
  title: string;
  pathname?: string;
  isActive?: boolean;
  scrollOffset?: number;
}

export interface TestimonialModel {
  quote?: string;
  name?: string;
  occupation?: string;
  imgsrc?: string;
}

export const navLinks: Array<LinkModel> = [
  { title: "For you", pathname: "/", isActive: true, scrollOffset: -50 },
  { title: "For Courier", pathname: "/", scrollOffset: -100 },
  { title: "For Business", pathname: "/", scrollOffset: -70 },
  { title: "Testimonial", pathname: "/", scrollOffset: -70 },
  { title: "API Docs", pathname: "", scrollOffset: -40 },
];

export const testimonial: Array<TestimonialModel> = [
  {
    quote: "Great product, great team",
    name: "Agbani Darego",
    occupation: "trader",
    imgsrc: jiffy,
  },

  {
    quote: "Jiffy actually makes the process seamless and more easier, kudos",
    name: "Jade Osiberu",
    occupation: "Software Developer",
    imgsrc: jiffy3,
  },

  {
    quote:
      "Oh men, this guys dey cook, i’ve been looking for something as cutting edge as this and here it is staring me in the face",
    name: "Lola Ray",
    occupation: "Instagram Influencer",
    imgsrc: jiffy2,
  },

  {
    quote: "Great product, great team",
    name: "Agbani Darego",
    occupation: "trader",
    imgsrc: jiffy,
  },

  {
    quote: "Jiffy actually makes the process seamless and more easier, kudos",
    name: "Jade Osiberu",
    occupation: "Software Developer",
    imgsrc: jiffy3,
  },

  {
    quote:
      "Oh men, this guys dey cook, i’ve been looking for something as cutting edge as this and here it is staring me in the face",
    name: "Lola Ray",
    occupation: "Instagram Influencer",
    imgsrc: jiffy2,
  },

  {
    quote: "Great product, great team",
    name: "Agbani Darego",
    occupation: "trader",
    imgsrc: jiffy,
  },

  {
    quote: "Jiffy actually makes the process seamless and more easier, kudos",
    name: "Jade Osiberu",
    occupation: "Software Developer",
    imgsrc: jiffy3,
  },

  {
    quote:
      "Oh men, this guys dey cook, i’ve been looking for something as cutting edge as this and here it is staring me in the face",
    name: "Lola Ray",
    occupation: "Instagram Influencer",
    imgsrc: jiffy2,
  },
];

export const values = [
  { text: "Delight customers " },
  { text: "Integrate seamlessly" },
  { text: "Clear manifest collection " },
  { text: "Jump start your deliveries" },
  { text: "Tracking and real time reporting" },
  { text: "One time and recurring deliveries " },
  { text: "Automate your business workflows " },
];
